import * as React from "react";
import {
  FieldSchema,
  FormControlSchema,
  ObjectFieldSchema,
  OtherFieldSchema
} from "@generation/core/src/Schema/Fields";
//eslint-disable-next-line import/no-cycle
import { RenderFieldSchemaComponent, RenderFields } from "../Read/RenderFields";
import { useDataContext, getObjectValueFromObject } from "@generation/overview-core";
import { withHideOnFieldHoc } from "../Hoc/withHideOnFieldHoc";

interface ObjectFieldProps {
  field: ObjectFieldSchema;
  name: string;
}

export const ObjectField = (
  renderAddedSchemaFields?: (name: string, field: OtherFieldSchema) => RenderFieldSchemaComponent
) =>
  withHideOnFieldHoc((props: ObjectFieldProps) => {
    const values = getObjectValueFromObject(useDataContext(), props.name);

    if (props.field.ui?.readOverview?.hideWhenAllPropertiesAreNotGiven === true) {
      if (
        values === null ||
        values === undefined ||
        Object.keys(values)
          .map((key) => values[key])
          .every((item) => item === undefined || (Array.isArray(item) && item.length === 0))
      ) {
        return <></>;
      }
    }

    const result = (
      <>
        {Object.entries(props.field.properties).map(([fieldName, objectField]) => (
          <React.Fragment key={`${props.name}.${fieldName}`}>
            <RenderFields
              field={objectField}
              name={`${props.name}.${fieldName}`}
              renderAddedSchemaFields={renderAddedSchemaFields}
            />
          </React.Fragment>
        ))}
        {
          props.field.overview?.render
          && props.field.overview.render(values)
        }
      </>
    );

    if (props.field.className !== undefined && props.field.className !== "") {
      return <div className={props.field.className}>{result}</div>;
    }

    return result;
  });
